import { Expose } from "class-transformer";
import { Model } from "./model";

export class OtpResponse extends Model {
  @Expose() message!: string;
  @Expose() cooldownSeconds!: number;
  @Expose() requiresRecaptchaV2?: boolean;
  @Expose() isNewCustomer?: boolean;
  @Expose() code?: string;
}
